export default {
    container: {
        width: '100%',
        background: 'gray.200',
        padding: '4',
        paddingBottom: '5'
    },
    title: {
        color: 'loyaltyT3',
        lineHeight: 1.14,
        textTransform: 'uppercase',
        fontWeight: 700,
        fontSize: 'sm'
    },
    text: {
        fontSize: 'sm',
        color: 'warmBlack',
        lineHeight: '18px',
        marginBottom: '10px'
    },
    button: {
        fontSize: 'sm',
        lineHeight: 'normal',
        padding: '8px 20px',
        height: '100%'
    }
}
